<div class="footer">
  <div class="footer__color-bar"></div>
  <div class="footer__body">
  <div class="footer__content">
    <div class="footer__logo">
      <img class="shield" alt="image" class="top25" src="images/picture0 2.png">
      <span class="footer__divider"></span>
      <svg-icon icon="logoc" size='fill' class="footer__icon"></svg-icon>
    </div>
    <div class="footer__terms">
      <p class="footer__terms-links">
        <span class="help-link">
          <a class="terms" href="/helpPage">
            {{labels.termsOfService}} <span class="footer__small-divider"></span> &copy; {{anio}} {{labels.comcast}}
          </a>
        </span>
      </p>
    </div>

    <div class="footer__links">
      @for(icon of socialIcons; track icon.name) {
      <span class="help-link footer-icons" [matTooltip]="icon.tooltip">
        <a [href]="icon.href" target="_blank">
          <i [class]="icon.classes"></i>
        </a>
      </span>
      }
    </div>
  </div>

  </div>
</div>

